<template>
  <div>
    <table-view
      ref="tableList"
      :tableModel="tableModel"
      :tableData="tableData"
      :searchModel="searchModel"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="LENOVO REPORTS LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <el-button
          type="primary"
          :loading="tableRow.row.loading"
          size="mini"
          round
          @click="handleDownload(tableRow)"
          v-if="tableRow.row.status === 1"
        >
          Download
        </el-button>
      </template>
    </table-view>
    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="462px"
      @close="handleCancel"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form :model="form" ref="form" label-position="top">
          <el-form-item label="Report Type" prop="type">
            <el-select
              v-model="form.type"
              style="width: 100%"
              @change="(form.startDate = '', form.endDate = '')"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <template v-if="[3, 4, 5].includes(form.type)">
            <el-form-item :label="monthLabel" prop="startDate">
              <el-date-picker
                style="width: 100%"
                v-model="form.startDate"
                value-format="yyyy-MM-dd"
                type="month"
              />
            </el-form-item>
          </template>
          <template v-if="form.type === 6">
            <el-form-item label="Date" prop="startDate">
              <el-date-picker
                style="width: 100%"
                v-model="form.startDate"
                value-format="yyyy-MM-dd"
                type="date"
              />
            </el-form-item>
          </template>
          <template v-if="form.type === 9">
            <el-form-item label="Start Time" prop="startDate">
              <el-date-picker
                style="width: 100%"
                v-model="form.startDate"
                value-format="yyyy-MM-dd"
                type="date"
              />
            </el-form-item>
            <el-form-item label="End Time" prop="endDate">
              <el-date-picker
                style="width: 100%"
                v-model="form.endDate"
                value-format="yyyy-MM-dd"
                type="date"
              />
            </el-form-item>
          </template>
          <template v-if="[7, 8].includes(form.type)">
            <el-form-item
              :label="`${form.type === 7 ? 'Expire Date' : 'Transaction Date'}`"
              prop="startDate"
            >
              <el-date-picker
                style="width: 100%"
                v-model="form.startDate"
                type="daterange"
                range-separator="-"
                start-placeholder="start"
                value-format="yyyy-MM-dd"
                end-placeholder="end"
              />
            </el-form-item>
          </template>
          <template v-if="![5, 6, 9].includes(form.type)">
            <el-form-item label="Geo" prop="geos">
              <el-select
                v-model="form.geos"
                placeholder="all"
                style="width: 100%"
                @change="handleChangeGeoSelect"
                clearable
                multiple
              >
                <el-option
                  v-for="item in GeoList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Region" prop="regions">
              <el-select
                v-model="form.regions"
                placeholder="all"
                @change="handleChangeRegionSelect"
                style="width: 100%"
                multiple
                clearable
              >
                <el-option
                  v-for="item in RegionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Sales Country" prop="salesCountrys">
              <el-select
                v-model="form.salesCountrys"
                placeholder="all"
                style="width: 100%"
                clearable
                multiple
              >
                <el-option
                  v-for="item in SalesCountryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="BU" prop="bus">
              <el-select
                v-model="form.bus"
                placeholder="all"
                style="width: 100%"
                clearable
                multiple
              >
                <el-option
                  v-for="item in BUList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Business Type" prop="businessTypes">
              <el-select
                v-model="form.businessTypes"
                placeholder="all"
                style="width: 100%"
                clearable
                multiple
              >
                <el-option
                  v-for="item in BusinessList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </template>
          <el-form-item v-if="form.type !== 9" label="Customer Type" prop="customerTypes">
            <el-select
              v-model="form.customerTypes"
              placeholder="all"
              style="width: 100%"
              clearable
              multiple
            >
              <el-option
                v-for="item in customerTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button
          class="clear-btn"
          style="margin-right: 20px"
          @click="handleCancel"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getSelectList } from '@/api'
import { getTableData, download, add, getMultiValueList } from './api'

const selectList = ['Geo', 'SalesCountry', 'BU', 'Business']

export default {
  data() {
    this.typeList = [
      {
        id: 1,
        name: 'Credit File',
      },
      {
        id: 2,
        name: 'Insurance Limit Report',
      },
      {
        id: 3,
        name: 'Month End AR',
      },
      {
        id: 4,
        name: 'MEP Report',
      },
      {
        id: 5,
        name: 'GA Review Monthly',
      },
      {
        id: 6,
        name: 'GA Review Weekly',
      },
      {
        id: 7,
        name: 'Collateral Report',
      },
      {
        id: 8,
        name: 'TAT Report',
      },
      {
        id: 9,
        name: 'AI Report',
      },
    ]
    const searchModel = [
      {
        label: 'Report Type',
        type: 'select',
        key: 'type',
        selectList: this.typeList,
      },
      {
        label: 'Status',
        type: 'select',
        key: 'status',
        selectList: [
          { id: 0, name: 'In Processing' },
          { id: 1, name: 'Success' },
          { id: 2, name: 'Failure' },
        ],
      },
    ]
    const tableModel = [
      {
        label: 'Report Type',
        prop: 'typeStr',
      },
      {
        label: 'Submitted By',
        prop: 'username',
      },
      {
        label: 'Status',
        prop: 'statusStr',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'GEO',
        prop: 'geos',
      },
      {
        label: 'Region',
        prop: 'regions',
      },
      {
        label: 'BU',
        prop: 'bus',
      },
      {
        label: 'Business Type',
        prop: 'businessTypes',
      },
      {
        label: 'Sales Country',
        prop: 'salesCountrys',
      },
      {
        label: 'Action',
        width: 150,
        slotName: 'action',
      },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        type: 1,
        geos: [],
        regions: [],
        salesCountrys: [],
        bus: [],
        businessTypes: [],
        customerTypes: [],
        startDate: '',
        endDate: '',
      },
      GeoList: [],
      RegionList: [],
      SalesCountryList: [],
      BUList: [],
      BusinessList: [],
      customerTypeList: [
        {
          id: 1,
          name: 'Trade',
        },
        {
          id: 2,
          name: 'Eaas',
        },
        {
          id: 3,
          name: 'Saas',
        },
      ],
      timer: null,
    }
  },
  mounted() {
    this.initTable()
    this._getSelectList()
  },
  computed: {
    monthLabel() {
      switch (this.form.type) {
        case 3:
          return 'AR Month'
        case 4:
        case 5:
          return 'Month'
        default:
          return ''
      }
    },
  },
  methods: {
    handleChangeRegionSelect(id) {
      if (!id) {
        this.form.salesCountrys = ''
        this.SalesCountryList = []
      } else {
        this._getCountryList(id.join())
      }
    },
    handleChangeGeoSelect(id) {
      if (!id) {
        this.form.regions = ''
        this.RegionList = []
      } else {
        this._getRegion(id.join())
      }
    },
    _getSelectList() {
      const promiseAll = selectList.map(type => getSelectList(type))

      Promise.all([...promiseAll]).then(res => {
        selectList.forEach((type, index) => (this[`${type}List`] = res[index]))
      })
    },
    async _getCountryList(pids) {
      try {
        this.SalesCountryList = await getMultiValueList({
          typeMark: 'Country',
          pids,
        })
      } catch (e) {
        console.error(e)
      }
    },
    async _getRegion(pids) {
      try {
        this.RegionList = await getMultiValueList({
          typeMark: 'Region',
          pids,
        })
      } catch (e) {
        console.error(e)
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data.map(item => ({ ...item, loading: false }))
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleCancel() {
      this.visible = false
      this.$refs.form.resetFields()
      this.fileList = []
    },
    async handleSaveBtn() {
      try {
        if (this.form.type === 9) {
          if (!this.form.startDate || !this.form.endDate) {
            return this.$message.error('Please select Start Time and End Time!')
          }
          if (new Date(this.form.startDate) > new Date(this.form.endDate)) {
            return this.$message.error('Start Time must be before End Time!')
          }
          this.timer = setTimeout(() => {
            this.initTable()
          }, 1000)
          this.visible = false
          await add(this._filterData({ ...this.form }))
        } else if ([1, 2, 3, 4, 7].includes(this.form.type)) {
          if (!this.form.geos) {
            return this.$message.error('Please add Geo!')
          } else {
            this.timer = setTimeout(() => {
              this.initTable()
            }, 1000)
            this.visible = false
            await add(this._filterData({ ...this.form }))
          }
        } else {
          this.timer = setTimeout(() => {
            this.initTable()
          }, 1000)
          this.visible = false
          await add(this._filterData({ ...this.form }))
        }
      } catch (e) {
        console.error(e)
      }
    },
    _filterData(data) {
      const result = { ...data }
      if (result.type === 9) {
        // Only send type, startDate and endDate for AI Report
        return {
          type: result.type,
          startDate: result.startDate,
          endDate: result.endDate,
        }
      }
      result.geos = result.geos.join()
      result.regions = result.regions.join()
      result.salesCountrys = result.salesCountrys.join()
      result.bus = result.bus.join()
      result.businessTypes = result.businessTypes.join()
      result.customerTypes = result.customerTypes.join()
      if ([7, 8].includes(result.type) && result.startDate.length) {
        result.endDate = result.startDate[1]
        result.startDate = result.startDate[0]
      }
      return result
    },
    async handleTitleActionBtn() {
      this.visible = true
    },
    handleChange(file) {
      if (file.response) return
      if (this.fileList.length < 5) {
        this.fileList.push(file)
      }
    },
    async handleDownload(data) {
      const {
        row: { fileUrl, fileName },
        $index,
      } = data

      this.tableData[$index]['loading'] = true
      try {
        await download({
          url: fileUrl,
          fileName,
        })
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
      this.tableData[$index]['loading'] = false
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>
